import React, { useState, useEffect } from 'react';

import Box from '@mui/material/Box';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import FormHelperText from '@mui/material/FormHelperText';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import DownloadIcon from '@mui/icons-material/Download';
import CustomTabPanel from '../../ui-components/CustomTabPanel';
import { a11yProps, updateNullOfObjectValues } from '../../helpers/helper';
import { getLocationList, downloadApplicationReport } from '../../actions/admin.actions';
import CircularProgress from '@mui/material/CircularProgress';
import Autocomplete from '@mui/material/Autocomplete';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import {useSelector} from 'react-redux';

function Report() {
  const formFields = {
    startDate: '',
    endDate: '',
    locationval:null,
    location: '',
    statusval:null,
    status: ''
  }
  //const [locations, setLocations] = useState([]);
  const {locations} = useSelector(state => state.userdata);
  const [tabValue, setTabValue] = useState(0);
  const [formValues, setFormValues] = useState(formFields);
  const [formErrors, setFormErrors] = useState(updateNullOfObjectValues(formFields));
  const [submitting, setSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(null);
  const [submitError, setSubmitError] = useState(null);

  useEffect(() => {
    // getLocationList({ all: 1 }).then((res) => {
    //   setLocations(res.data.data.locations);
    // }).catch((error) => {
    //   console.log(error);
    // });
  }, []);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  }

  const handleStartDate = (vl) => {
    setFormErrors(updateNullOfObjectValues(formFields));
    setFormValues({ ...formValues, startDate: vl });
  }
  const handleEndDate = (vl) => {
    setFormErrors(updateNullOfObjectValues(formFields));
    setFormValues({ ...formValues, endDate: vl });
  }

  const StatusList = [
    { lable: 'Pending', value: 'Pending' },
    { lable: 'Approved', value: 'Approved' },
    { lable: 'Rejected', value: 'Rejected' }
  ]
  const handleLocationSearchInput = (v) => {
    
    if(v!=null){
        setFormValues({
            ...formValues,
            locationval: v,
            location: v.location_id,
           
          });
    }else{
        setFormValues({
            ...formValues,
            locationval: null,
            location: '',
           
          });
    }

  }

  const handleStatusSearchInput = (v) => {
     console.log(v);
    if(v!=null){
        setFormValues({
            ...formValues,
            statusval: v,
            status: v.value,
           
          });
    }else{
        setFormValues({
            ...formValues,
            statusval: null,
            status: '',
           
          });
    }

  }
  const handleDownload = () => {
    if (validate()) {
      setSubmitting(true);
      setSubmitError(null);
      let formData = {};
      if (tabValue === 0) {
        
        if(formValues.location!='' && formValues.status==''){
          formData = {
            start_date: formValues.startDate.format('YYYY-MM-DD'),
            end_date: formValues.endDate.format('YYYY-MM-DD'),
            location: formValues.location
          }
        }
       else if(formValues.status!=''&& formValues.location==''){
          formData = {
            start_date: formValues.startDate.format('YYYY-MM-DD'),
            end_date: formValues.endDate.format('YYYY-MM-DD'),
            status: formValues.status
          }
        }else if(formValues.status!=''&& formValues.location!=''){
          formData = {
            start_date: formValues.startDate.format('YYYY-MM-DD'),
            end_date: formValues.endDate.format('YYYY-MM-DD'),
            status: formValues.status,
            location: formValues.location
          }
        }else{
          formData = {
            start_date: formValues.startDate.format('YYYY-MM-DD'),
            end_date: formValues.endDate.format('YYYY-MM-DD')
          }
        }
       
      }
      console.log(formValues);
      console.log(formData);
      downloadApplicationReport(formData).then((res) => {
        if (res.data.status) {
          generateCSV(res.data.data);
        } else {
          setSubmitError('No Application found');
        }
        setSubmitting(false);
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  const generateCSV = (data) => {
    let temp_csv = Array(0);
     console.log(data);
    if (data.length) {
      for (let i = 0; i < data.length; i++) {
        var consentfrom =data[i].document_details.length;
        var physicianfrom =data[i].physician_document_details.length ;
        var physiciantconsent = 0;
        var consentfromnew=0;
        console.log(consentfrom);
        if(consentfrom==1){
          consentfromnew=consentfrom+' Form Uploaded';
        }else{
          consentfromnew=consentfrom+' Forms Uploaded';
        }
        console.log(consentfromnew);
        if(physicianfrom>0){
          if(physicianfrom==1){
            physiciantconsent=physicianfrom+' Physician Form Uploaded';
          }else{
            physiciantconsent=physicianfrom+' Physician Forms Uploaded';
          }
         
        }else{
          physiciantconsent='No Physician Form Uploaded';
        }
    var nursename='';
        if(data[i].nurse_details!=null){
           console.log(data[i].nurse_details);
          nursename=data[i].nurse_details.name+' '+data[i].nurse_details.last_name;
          console.log(nursename);
        }
         
        temp_csv.push([
          data[i].stuid,
          data[i].school_name,
          data[i].student_name+' '+data[i].last_name,
          data[i].stu_grade,
          consentfromnew,
         physiciantconsent,
          nursename,
          data[i].consent_details.status
         
        ]);
      }

      let headers = ['Student ID, Location, Student Name, Grade, Parent Consent Form, Physician Form, Updated By,Status']
      downloadFile({
        data: [...headers, ...temp_csv].join('\n'),
        fileName: 'Application_Report.csv',
        fileType: 'text/csv;charset=utf-8;',
      })
    }
  }

  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob(['\ufeff' + data], { type: fileType })

    const a = document.createElement('a')
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    console.log(a);
    const clickEvt = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }


  const validate = () => {
    let errors = {};
    let formIsValid = true;

    if (tabValue === 0) {
      if (!formValues.startDate) {
        formIsValid = false;
        errors['startDate'] = 'Start Date is required';
      }
      if (!formValues.endDate) {
        formIsValid = false;
        errors['endDate'] = 'End Date is required';
      }
    } else if (tabValue === 1) {

    } else if (tabValue === 2) {

    }

    setFormErrors(errors);
    return formIsValid;
  }


  return (
    <Typography paragraph>
      <div className='row'>
        <div className='col-md-12'>
          <div className='club-sec application-sec tab-main'>
            <div className='container-fluid '>

              <div className='club-inner-secss form-table-sec table-section-route table-form appl-sec admin-top-sec' style={{ marginTop: '5px' }}>
                <Box sx={{ width: '100%' }}>
                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={tabValue} onChange={handleTabChange} aria-label="basic tabs example">
                      <Tab label=" Report" {...a11yProps(0)} />
                      {/* <Tab label="By Location" {...a11yProps(1)} />
                      <Tab label="By Status" {...a11yProps(2)} /> */}
                    </Tabs>
                  </Box>
                  <CustomTabPanel value={tabValue} index={0} class="manage-sec-nw manage-sec-nwss" >
                    <div className='report-main-sec'>
                      <div className='container-fluid'>
                        <div className='row'>
                          <div className='col-md-3 dat-cal-sec'>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoContainer
                                components={[
                                  'DatePicker',
                                  'MobileDatePicker',
                                  'DesktopDatePicker',
                                  'StaticDatePicker',
                                ]}
                              >
                                <DemoItem >
                                  {/* <MobileDatePicker defaultValue={dayjs('2022-04-17')} /> */}
                                  <MobileDatePicker label="Start Date" className='requireds' onChange={handleStartDate} value={dayjs(formValues.startDate)} />
                                </DemoItem>
                              </DemoContainer>
                            </LocalizationProvider>
                            {
                              formErrors.startDate && <div className='help-imper-error'><FormHelperText className='manual_error'>{formErrors.startDate}</FormHelperText></div>
                            }
                          </div>
                          <div className='col-md-3 dat-cal-sec'>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoContainer
                                components={[
                                  'DatePicker',
                                  'MobileDatePicker',
                                  'DesktopDatePicker',
                                  'StaticDatePicker',
                                ]}
                              >
                                <DemoItem >
                                  {/* <MobileDatePicker defaultValue={dayjs('2022-04-17')} /> */}
                                  <MobileDatePicker label="End Date" className='requireds' onChange={handleEndDate} value={dayjs(formValues.endDate)} />
                                </DemoItem>
                              </DemoContainer>
                            </LocalizationProvider>
                            {
                              formErrors.endDate && <div className='help-imper-error'><FormHelperText className='manual_error'>{formErrors.endDate}</FormHelperText></div>
                            }
                          </div>
                          <div className='col-md-3 dat-cal-sec  dat-new-scd'>
                          <div className='admn-selct-sec filtr-nwe-sec reprt-filter-sec'>
                                          <Autocomplete
                                            id="tags-standard"
                                            value={formValues.locationval || null}
                                            options={locations}
                                            getOptionLabel={(option) => option.locationName}
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            onChange={(e,v) => handleLocationSearchInput(v)}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                variant="standard"
                                                placeholder="Location"
                                              />
                                            )}
                                            renderOption={(props, option) => {
                                              return (
                                                <li {...props} key={option.id}>
                                                  {option.locationName}
                                                </li>
                                              );
                                            }}
                                            renderTags={(tagValue, getTagProps) => {
                                              return tagValue.map((option, index) => (
                                                <Chip {...getTagProps({ index })} key={option.id} label={option.locationName} />
                                              ))
                                            }}
                                          />
                                        </div>
                                        </div>
                                        <div className='col-md-3 dat-cal-sec  dat-new-scd'>
                                        <div className='admn-selct-sec filtr-nwe-sec reprt-filter-sec'>
                                                <Autocomplete
                                                  id="tags-standard"
                                                  value={formValues.statusval || null}
                                                  options={StatusList}
                                                  getOptionLabel={(option) => option.lable}
                                                  isOptionEqualToValue={(option, value) => option.value === value.value}
                                                  onChange={(e,v) => handleStatusSearchInput(v)}
                                                  renderInput={(params) => (
                                                    <TextField
                                                      {...params}
                                                      variant="standard"
                                                      placeholder="Status"
                                                    />
                                                  )}
                                                  renderOption={(props, option) => {
                                                    return (
                                                      <li {...props} key={option.id}>
                                                        {option.lable}
                                                      </li>
                                                    );
                                                  }}
                                                  renderTags={(tagValue, getTagProps) => {
                                                    return tagValue.map((option, index) => (
                                                      <Chip {...getTagProps({ index })} key={option.id} label={option.lable} />
                                                    ))
                                                  }}
                                                />
                                              </div>
                                          </div>
                         
                        </div>

                        <div className='row'>
                        <div className='col-md-12 dat-cal-sec reprt-sec'>
                            <div class="login-submit login-submitss btn-adm adm-dwnss">
                              <button class="btn btn-login btn-submit bt-forms btn-downld" type='button' onClick={handleDownload}>Download <span className='btn-dwn-span'><DownloadIcon /> </span> {submitting && <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "white" }} />}</button>
                            </div>
                          </div>
                        </div>
                        {
                submitSuccess ?
                  <div className="custome-vali custom-success-msg">
                    <p> {submitSuccess}</p>
                   
                  </div>
                  : null
              }
              {
                submitError ?
                  <div className="custome-vali custom-error-msg" >
                    <p>{submitError}</p>
                  </div>
                  : null
              }
                      </div>
                    </div>
                  </CustomTabPanel>
                  <CustomTabPanel value={tabValue} index={1} class="manage-sec-nw manage-sec-nwss" >
                    <div className='report-main-sec'>
                      <div className='container-fluid'>
                        <div className='row'>
                          <div className='col-md-3 dat-cal-sec'>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoContainer
                                components={[
                                  'DatePicker',
                                  'MobileDatePicker',
                                  'DesktopDatePicker',
                                  'StaticDatePicker',
                                ]}
                              >

                                <DemoItem >
                                  {/* <MobileDatePicker defaultValue={dayjs('2022-04-17')} /> */}
                                  <MobileDatePicker label="Start Date" />
                                </DemoItem>


                              </DemoContainer>
                            </LocalizationProvider>
                          </div>
                          <div className='col-md-3 dat-cal-sec'>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoContainer
                                components={[
                                  'DatePicker',
                                  'MobileDatePicker',
                                  'DesktopDatePicker',
                                  'StaticDatePicker',
                                ]}
                              >

                                <DemoItem >
                                  {/* <MobileDatePicker defaultValue={dayjs('2022-04-17')} /> */}
                                  <MobileDatePicker label="End Date" />
                                </DemoItem>


                              </DemoContainer>
                            </LocalizationProvider>
                          </div>
                          <div className='col-md-3'>
                          
                          </div>
                          <div className='col-md-3 dat-cal-sec'>
                            <div class="login-submit login-submitss btn-adm adm-dwnss">
                              <button class="btn btn-login btn-submit bt-forms btn-downld" type='button'>Download <span className='btn-dwn-span'><DownloadIcon /> </span></button>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CustomTabPanel>
                  <CustomTabPanel value={tabValue} index={2}>
                    By Status
                  </CustomTabPanel>
                </Box>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Typography>

  );
}
export default Report;

